<template>
  <div>
    <v-row class="mx-1 mt-4">
      <v-autocomplete
        :search-input.sync="searchCountryInput"
        @change="searchCountryInput = ''"
        v-model="selectedCountries"
        :items="countriesData"
        clearable
        placeholder="Select countries"
        multiple></v-autocomplete>
    </v-row>
    <v-row class="mx-1 mt-4">
      <v-autocomplete
        :search-input.sync="searchStateInput"
        @change="searchStateInput = ''"
        v-model="selectedStates"
        :items="statesData"
        clearable
        placeholder="Select states"
        multiple></v-autocomplete>
    </v-row>
    <v-row class="mx-1 mt-4">
      <v-autocomplete
        :search-input.sync="searchCityInput"
        @change="searchCityInput = ''"
        v-model="selectedCities"
        clearable
        :items="citiesData"
        placeholder="Select cities"
        multiple></v-autocomplete>
    </v-row>

    <v-row class="mx-1 mt-4">
      <v-autocomplete
        :search-input.sync="searchCountyInput"
        @change="searchCountyInput = ''"
        v-model="selectedCounties"
        clearable
        :items="countiesData"
        placeholder="Select counties"
        multiple></v-autocomplete>
    </v-row>
    <v-row class="mx-1 mb-4">
      <v-select
        class="device__select"
        multiple
        clearable
        v-model="selectedDevices"
        :items="devices"
        placeholder="Select device"
        :menu-props="{ offsetY: true, offsetOverflow: true }"></v-select>
    </v-row>

    <v-row class="mt-4 mx-1">
      <v-checkbox v-model="enableUTMParameters" label="Enable UTM parameters"></v-checkbox>
      <div class="mb-auto">
        <info-tooltip
          :info="'This will enable UTM parameter matching. It will also enable UTM_SOURCE presence'"></info-tooltip>
      </div>
    </v-row>

    <div v-if="enableUTMParameters">
      <v-row no-gutters class="mt-1 mx-1">
        <v-col cols="6" class="pr-2">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field disabled value="UTM_SOURCE="></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field clearable v-model="utmSource" placeholder="SOURCE"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pl-2" cols="6">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field disabled value="UTM_MEDIUM="></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field clearable v-model="utmMedium" placeholder="MEDIUM"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-1 mx-1">
        <v-col cols="6" class="pr-2">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field disabled value="UTM_CAMPAIGN="></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field clearable v-model="utmCampaign" placeholder="CAMPAIGN"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pl-2" cols="6">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field disabled value="UTM_TERM="></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field clearable v-model="utmTerm" placeholder="TERM"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-2 mx-1">
        <v-col cols="6" class="pr-2">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field disabled value="UTM_CONTENT="></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field clearable v-model="utmContent" placeholder="CONTENT"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <!---JSON code-->
    <div class="mt-6 mx-1" :class="[jsonFormatError ? 'json-error' : '']">
      <div>
        <span>JSON </span>
        <info-tooltip :info="'You can edit JSON below, for quicker access'"></info-tooltip>
      </div>
      <code-input :key="jsonInputKey" v-model="formJson" :title="''"></code-input>
      <p class="content-split-error">{{ jsonFormatError ? "Wrong JSON format" : "" }}</p>
    </div>
  </div>
</template>

<script>
  // Components
  import CodeInput from "@/components/custom/CodeInput";
  import InfoTooltip from "@/components/custom/InfoTooltip";
  // Data
  import statesData from "@/assets/data/states";
  import citiesData from "@/assets/data/cities";
  import countiesData from "@/assets/data/counties";
  import countriesData from "@/assets/data/countries";

  export default {
    components: {
      CodeInput,
      InfoTooltip,
    },
    data() {
      return {
        enableUTMParameters: false,
        searchStateInput: "",
        statesData: statesData,
        selectedStates: [],

        searchCityInput: "",
        citiesData: citiesData,
        selectedCities: [],

        searchCountyInput: "",
        countiesData: countiesData,
        selectedCounties: [],

        searchCountryInput: "",
        countriesData: countriesData,
        selectedCountries: [],

        selectedDevices: [],
        devices: [
          {
            text: "Desktop",
            value: "desktop",
          },
          {
            text: "Tablet",
            value: "tablet",
          },
          {
            text: "Smartphone",
            value: "smartphone",
          },
        ],

        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        utmContent: null,

        /**
         * When editing JSON input (code-input), user might make the JSON inside of the code-input invalid;
         * jsonFormatError is true if JSON format inside of the code-input is incorrect (not parseable using JSON.parse)
         */
        jsonFormatError: false,
        paramData: null,
        jsonInputKey: 0,
      };
    },
    computed: {
      formJson: {
        get() {
          const displayData = {
            selectedStates: this.selectedStates,
            selectedCities: this.selectedCities,
            selectedCounties: this.selectedCounties,
            selectedCountries: this.selectedCountries,
            selectedDevices: this.selectedDevices,

            enableUTMParameters: this.enableUTMParameters,

            utmSource: this.utmSource,
            utmMedium: this.utmMedium,
            utmCampaign: this.utmCampaign,
            utmTerm: this.utmTerm,
            utmContent: this.utmContent,
          };

          return JSON.stringify(displayData, null, " ");
        },
        set(value) {
          let parsedJson;
          try {
            this.jsonFormatError = false;
            parsedJson = JSON.parse(value);
          } catch (e) {
            this.jsonFormatError = true;
          }

          if (!this.jsonFormatError) {
            this.selectedStates = parsedJson.selectedStates;
            this.selectedCities = parsedJson.selectedCities;
            this.selectedCounties = parsedJson.selectedCounties;
            this.selectedCountries = parsedJson.selectedCountries;
            this.selectedDevices = parsedJson.selectedDevices;

            this.enableUTMParameters = parsedJson.enableUTMParameters;

            this.utmSource = parsedJson.utmSource;
            this.utmMedium = parsedJson.utmMedium;
            this.utmCampaign = parsedJson.utmCampaign;
            this.utmTerm = parsedJson.utmTerm;
            this.utmContent = parsedJson.utmContent;
          }
        },
      },
      /**
       * Data that will be emitted via postMessage
       */
      emitData() {
        return {
          selectedStates: this.selectedStates,
          selectedCounties: this.selectedCounties,
          selectedCountries: this.selectedCountries,
          selectedCities: this.selectedCities,
          selectedDevices: this.selectedDevices,

          enableUTMParameters: this.enableUTMParameters,

          utmSource: this.utmSource,
          utmMedium: this.utmMedium,
          utmCampaign: this.utmCampaign,
          utmTerm: this.utmTerm,
          utmContent: this.utmContent,
        };
      },
    },
    watch: {
      selectedStates: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      selectedCities: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      selectedCounties: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      selectedCountries: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      selectedDevices: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      utmSource: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      utmMedium: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      utmCampaign: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      utmTerm: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      utmContent: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
      enableUTMParameters: {
        deep: true,
        handler() {
          this.updateValue(this.emitData);
        },
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();

      return;
    },
    methods: {
      updateValue(val) {
        const stringifiedData = btoa(JSON.stringify(val));

        window.parent.postMessage(
          {
            mceAction: "updateData",
            data: stringifiedData,
          },
          origin,
        );
      },
      setupReceiveDataListener() {
        window.onmessage = message => {
          if (message.data.type === "sendData") {
            // Format and set the received data
            const { data } = message.data;

            const jsonData = JSON.parse(atob(data));

            this.selectedStates = jsonData?.selectedStates;
            this.selectedCities = jsonData?.selectedCities;
            this.selectedCounties = jsonData?.selectedCounties;
            this.selectedCountries = jsonData?.selectedCountries;
            this.selectedDevices = jsonData?.selectedDevices;

            this.enableUTMParameters = jsonData?.enableUTMParameters;

            this.utmSource = jsonData?.utmSource;
            this.utmMedium = jsonData?.utmMedium;
            this.utmCampaign = jsonData?.utmCampaign;
            this.utmTerm = jsonData?.utmTerm;
            this.utmContent = jsonData?.utmContent;
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: "requestData",
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../@core/preset/preset/typography/index.scss";
  @import "../@core/preset/preset/functions.scss";

  .json-error {
    border: 1px solid get-color("error");
    border-radius: 5px;
    padding: 5px;
    &::v-deep {
      .va-code-input__label {
        color: get-color("error");
      }
    }
  }
  .content-split-error {
    @include text-caption();
    color: get-color("error");
    margin-top: 5px;
  }

  .device__select {
    &::v-deep {
      &.v-input.v-select.v-select--is-multi:not(.v-input.v-autocomplete) .v-select__selections {
        display: flex;
      }
    }
  }
</style>
